import { nextTick } from 'vue';

// Remembers what had focus when something opened and puts focus back when it closes, so a
// keyboard user lands where they were instead of at the top of the page.
export function useFocusReturn(): { remember: () => void; restore: (fallback?: () => HTMLElement | null) => void } {
  let opener: HTMLElement | null = null;

  function remember(): void {
    opener = typeof document === 'undefined' ? null : (document.activeElement as HTMLElement | null);
  }

  function restore(fallback?: () => HTMLElement | null): void {
    const target = opener;
    opener = null;
    if (!target && !fallback) return;
    void nextTick(() => {
      const element = target?.isConnected ? target : (fallback?.() ?? null);
      element?.focus();
    });
  }

  return { remember, restore };
}
